"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Vimeo = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M16.72912,14.67072 C14.55376,17.50368 12.71328,18.92 11.20768,18.92 C10.27536,18.92 9.48576,18.0576 8.84128,16.33216 C8.41056,14.75056 7.98032,13.16912 7.54976,11.58752 C7.07088,9.86304 6.55744,8.99968 6.00848,8.99968 C5.8888,8.99968 5.46992,9.252 4.7528,9.75472 L4,8.78304 C4.7896,8.08784 5.56864,7.3928 6.33504,6.6968 C7.38816,5.78496 8.17872,5.30544 8.7056,5.25696 C9.95088,5.13712 10.71728,5.98992 11.00496,7.81552 C11.31584,9.78512 11.53088,11.01024 11.65184,11.48976 C12.01072,13.12384 12.4056,13.93984 12.83712,13.93984 C13.172,13.93984 13.67504,13.40992 14.34576,12.35008 C15.01584,11.28992 15.37472,10.48336 15.4232,9.92928 C15.51856,9.0144 15.15952,8.55584 14.34576,8.55584 C13.96272,8.55584 13.56784,8.64416 13.1616,8.81872 C13.94784,6.23808 15.45024,4.9848 17.66784,5.05632 C19.31184,5.10464 20.08688,6.17296 19.99216,8.26144 C19.92096,9.82192 18.83312,11.95872 16.72912,14.67072 Z" })));
};
Vimeo.displayName = 'Vimeo';
exports.default = Vimeo;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Vimeo.js.map